interface ButtonProps {
  href: string
}

const Button = ({ href }: ButtonProps) => {
  return (
    <div className="mb-10 text-right">
      <button>
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className={`transition-border self-end rounded-md bg-mustard p-3 text-lg font-bold transition-colors duration-1000 dark:bg-green-500 dark:text-black`}
        >
          Registruotis
        </a>
      </button>
    </div>
  )
}

export default Button
